import React, { useState } from "react";
import "./QuestionDetailForm.css";
import Select from "react-select";

function PersonalityQuestionDetailForm({ question, onClose, onSave }) {
  const [formData, setFormData] = useState({ ...question });

  const questionClasses = ["Extraversion", "Agreeableness", "Conscientiousness", "Emotional Stability", "Intellect/Imagination"]
  const allRoles = [
    { value: "Admin", label: "Admin" },
    { value: "Software Developer", label: "Software Developer" },
    { value: "Tester", label: "Tester" },
    { value: "Software Architect", label: "Software Architect" },
    { value: "Product Manager", label: "Product Manager" },
    { value: "Business Analyst", label: "Business Analyst" },
    { value: "Product Owner", label: "Product Owner" },
    { value: "UI/UX", label: "UI/UX" },
    { value: "DevOps Engineer", label: "DevOps Engineer" },
    { value: "Practitioner", label: "Practitioner" },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>
          ×
        </button>
        <h3>Edit Personality Quiz Question</h3>
        <form onSubmit={handleSubmit}>
          <label>
            Question Text:
            <textarea
              name="questionText"
              value={formData.questionText}
              onChange={handleChange}
              required
              rows={4}
            />
          </label>
          <div className="form-row">
            <label>
              Category:
              <select
                required
                name="questionClass"
                value={formData.questionClass}
                onChange={handleChange}
              >
                {questionClasses.map((c) => (
                  <option key={c}>{c}</option>
                ))}
              </select>
            </label>
            <label>
              Score:
              <select
                required
                name="score"
                value={formData.score}
                onChange={handleChange}
              >
                <option value="positive">Positive</option>
                <option value="negative">Negative</option>
              </select>
            </label>
          </div>
          <label>
            <input
              type="checkbox"
              checked={formData.enabled}
              onChange={(e) =>
                setFormData({ ...formData, enabled: e.target.checked })
              }
            />
            Enabled
          </label>
          <label>
            Visible To Roles:
            <Select
              required
              isMulti
              closeMenuOnSelect={false}
              options={allRoles}
              value={formData.visibleToRoles.map((role) => ({
                value: role,
                label: role,
              }))}
              onChange={(selectedOptions) => {
                setFormData((prev) => ({
                  ...prev,
                  visibleToRoles: selectedOptions.map((option) => option.value),
                }));
              }}
            />
          </label>

          <div className="modal-buttons">
            <button className="blue-button" type="submit">
              Save
            </button>
            <button className="red-button" type="button" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default PersonalityQuestionDetailForm;
